import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertExperienceListComponent from './advertExperienceList.component';

let advertExperienceListModule = angular.module('advertExperienceList', [
  uiRouter
])

.component('advertExperienceList', advertExperienceListComponent)

.name;

export default advertExperienceListModule;
